<template>
	<div class="product_list">
		<ClassSelectList :show_detail='show_class_detail'></ClassSelectList>
		<CopyrightBottom></CopyrightBottom>
	</div>
</template>

<script type="text/javascript">
	import Vue from "vue";
	import store from '@/store/index.js';

	export default{
		name:"productList",
		data(){
			return{
				show_class_detail:true
			}
		},

		computed:{
		},

		methods:{
		}
	}

</script>

<style type="text/css" scoped>
	.product_list{
		margin-top: 50px;
	}
	ul{
		padding:0px; 
	}
	li{
		list-style-type: none;
	}

	canvas {
		display: block;
		position: absolute;
		bottom: 100px;
		right: -24px;
		z-index: 20;
		cursor: pointer;
		-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	}
</style>


// WEBPACK FOOTER //
// src/pages/productList.vue